export default 'pip install PyJWT';
